import { FEATURE_KEYS } from '../../shared/types/featureKey';
import type { TrendSignalKey } from './types';

export const TREND_TIME_TICK_SECONDS = 300;
export const FETCH_CONCURRENCY = 4;
export const EVENT_PARSE_BATCH = 16;
export const METRICS_WARM_BATCH = 8;
export const OVERLAY_SELECT_ALL_VALUE = 'select-all';

export { FEATURE_KEYS };

export const TREND_SIGNAL_KEYS: TrendSignalKey[] = [...FEATURE_KEYS, 'RR'];

export const TREND_FEATURE_LABELS: Record<TrendSignalKey, string> = {
  HR: 'HR',
  HRV: 'HRV',
  LF: 'LF',
  HF: 'HF',
  RR: 'RR',
};

export const OVERLAY_SESSION_COLORS = [
  '#dc2626',
  '#ea580c',
  '#ca8a04',
  '#65a30d',
  '#0891b2',
  '#7c3aed',
  '#db2777',
  '#c026d3',
  '#0f766e',
  '#b45309',
  '#2563eb',
];

export const getOverlaySeriesKey = (sessionId: number) =>
  `session_${sessionId}`;

export const getOverlayColor = (sessionId: number) =>
  OVERLAY_SESSION_COLORS[Math.abs(sessionId) % OVERLAY_SESSION_COLORS.length];
